(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[280],{

/***/ 9283:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projektit",
      function () {
        return __webpack_require__(6809);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



var Advert = function(param) {
    var language = param.language;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            window.adsbygoogle = window.adsbygoogle || [];
            window.adsbygoogle.push({});
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            background: "#ffffff07",
            marginTop: "1rem"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: language === "en" ? "Advertisement" : "Mainos"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
                className: "adsbygoogle",
                style: {
                    display: "block"
                },
                "data-ad-client": "ca-pub-5560402633923389",
                "data-ad-slot": "1051764153",
                "data-ad-format": "auto",
                "data-full-width-responsive": "true"
            })
        ]
    }, router.asPath);
};
/* harmony default export */ __webpack_exports__["Z"] = (Advert);


/***/ }),

/***/ 4438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2106);
/* harmony import */ var _styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2__);



var Post = function(param) {
    var post = param.post, _compact = param.compact, compact = _compact === void 0 ? false : _compact, language = param.language;
    var blogInLanguage = language === "en" ? "blog" : "blogi";
    var postInLanguage = language === "en" ? "post" : "julkaisu";
    var pageInLanguage = language === "en" ? "page" : "sivu";
    if (typeof post.tags === "string") {
        post.tags = post.tags.split(",").map(function(tag) {
            return tag.trim();
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Post),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Title),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(post.altPath || "".concat(blogInLanguage, "/").concat(postInLanguage), "/").concat(post.slug),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: post.title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Excerpt),
                children: post.excerpt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Tags),
                children: post.tags && post.tags.map(function(tag) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/".concat(blogInLanguage, "/").concat(tag.toLowerCase(), "/").concat(pageInLanguage, "/1"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Tag),
                            children: tag
                        })
                    }, tag);
                })
            }),
            !compact && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/".concat(post.altPath || "".concat(blogInLanguage, "/").concat(postInLanguage), "/").concat(post.slug),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    "aria-label": "".concat(language === "en" ? "Open post" : "Avaa julkaisu", " ").concat(post.title),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                        children: [
                            language === "en" ? "Read more" : "Lue lis\xe4\xe4",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: (_styles_Post_module_css__WEBPACK_IMPORTED_MODULE_2___default().Arrow),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Post);


/***/ }),

/***/ 5314:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var projects = {
    fi: [
        {
            slug: "compress-create-react-app",
            title: "compress-create-react-app (englanniksi)",
            excerpt: "NPM paketti, jonka avulla create-react-app sivuistohin voidaan lis\xe4t\xe4 kompressointi minimaalisella vaivalla.",
            altPath: "projektit"
        }, 
    ],
    en: [
        {
            slug: "compress-create-react-app",
            title: "compress-create-react-app",
            excerpt: "An NPM package which allows adding post build compression to a create-react-app with minimal configuration.",
            altPath: "projects"
        }, 
    ]
};
/* harmony default export */ __webpack_exports__["Z"] = (projects);


/***/ }),

/***/ 6809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Advert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1682);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3510);
/* harmony import */ var _components_Post__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4438);
/* harmony import */ var _data_projects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5314);





var ProjectsPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: "Projektit | Joonas Niemenjoki",
        language: "fi",
        i18n: "https://niemenjoki.fi/projects",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                children: "Projektit"
            }),
            _data_projects__WEBPACK_IMPORTED_MODULE_4__/* ["default"].fi.map */ .Z.fi.map(function(project, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Post__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    post: project,
                    language: "fi"
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Advert__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                language: "fi"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ProjectsPage);


/***/ }),

/***/ 2106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Post":"Post_Post__y18Vk","Title":"Post_Title__iKyDh","Excerpt":"Post_Excerpt__yMdge","Tags":"Post_Tags__we__h","Tag":"Post_Tag__D57Ir","Arrow":"Post_Arrow__jth_i"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,913,510,774,888,179], function() { return __webpack_exec__(9283); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);